/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { BodyVoucherActivationResolutionResponse } from '../_model/bodyVoucherActivationResolutionResponse';
import type { ClaimVoucherReq } from '../_model/claimVoucherReq';
import type { GetMyVouchersParams } from '../_model/getMyVouchersParams';
import type { GetVoucherStatsParams } from '../_model/getVoucherStatsParams';
import type { SuccessBodyTrialOfferClaimRes } from '../_model/successBodyTrialOfferClaimRes';
import type { SuccessBodyUserVoucherRes } from '../_model/successBodyUserVoucherRes';
import type { SuccessBodyUserVouchersRes } from '../_model/successBodyUserVouchersRes';
import type { SuccessBodyVoucherStatsRes } from '../_model/successBodyVoucherStatsRes';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 내 쿠폰함의 바우처를 사용하여 무료 플랜을 활성화합니다
 * @summary 바우처 사용
 */
export const activateVoucher = (
  voucherHashId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<BodyVoucherActivationResolutionResponse>(
    { url: `/vouchers/${voucherHashId}/activate`, method: 'POST', signal },
    options,
  );
};

export const getActivateVoucherMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateVoucher>>,
    TError,
    { voucherHashId: string },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateVoucher>>,
  TError,
  { voucherHashId: string },
  TContext
> => {
  const mutationKey = ['activateVoucher'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateVoucher>>,
    { voucherHashId: string }
  > = props => {
    const { voucherHashId } = props ?? {};

    return activateVoucher(voucherHashId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateVoucherMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateVoucher>>
>;

export type ActivateVoucherMutationError = ErrorType<unknown>;

/**
 * @summary 바우처 사용
 */
export const useActivateVoucher = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof activateVoucher>>,
      TError,
      { voucherHashId: string },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof activateVoucher>>,
  TError,
  { voucherHashId: string },
  TContext
> => {
  const mutationOptions = getActivateVoucherMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * GET /vouchers/my 의 trialOffer=TWO_WEEKS_FREE 제안을 수락해 이용권을 발급받습니다. 발급 시점에 대상자 판정을 다시 하며, 반복 호출은 멱등입니다.
 * @summary 2주 무료체험 제안 받기
 */
export const claimTrialOffer = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyTrialOfferClaimRes>(
    { url: `/vouchers/trial-offer/claim`, method: 'POST', signal },
    options,
  );
};

export const getClaimTrialOfferMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof claimTrialOffer>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof claimTrialOffer>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['claimTrialOffer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof claimTrialOffer>>,
    void
  > = () => {
    return claimTrialOffer(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClaimTrialOfferMutationResult = NonNullable<
  Awaited<ReturnType<typeof claimTrialOffer>>
>;

export type ClaimTrialOfferMutationError = ErrorType<unknown>;

/**
 * @summary 2주 무료체험 제안 받기
 */
export const useClaimTrialOffer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof claimTrialOffer>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof claimTrialOffer>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getClaimTrialOfferMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 바우처 코드를 내 쿠폰함에 등록합니다
 * @summary 바우처 등록
 */
export const claimVoucher = (
  claimVoucherReq: BodyType<ClaimVoucherReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyUserVoucherRes>(
    {
      url: `/vouchers/claim`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: claimVoucherReq,
      signal,
    },
    options,
  );
};

export const getClaimVoucherMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof claimVoucher>>,
    TError,
    { data: BodyType<ClaimVoucherReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof claimVoucher>>,
  TError,
  { data: BodyType<ClaimVoucherReq> },
  TContext
> => {
  const mutationKey = ['claimVoucher'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof claimVoucher>>,
    { data: BodyType<ClaimVoucherReq> }
  > = props => {
    const { data } = props ?? {};

    return claimVoucher(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClaimVoucherMutationResult = NonNullable<
  Awaited<ReturnType<typeof claimVoucher>>
>;
export type ClaimVoucherMutationBody = BodyType<ClaimVoucherReq>;
export type ClaimVoucherMutationError = ErrorType<unknown>;

/**
 * @summary 바우처 등록
 */
export const useClaimVoucher = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof claimVoucher>>,
      TError,
      { data: BodyType<ClaimVoucherReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof claimVoucher>>,
  TError,
  { data: BodyType<ClaimVoucherReq> },
  TContext
> => {
  const mutationOptions = getClaimVoucherMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * X-Token으로 바우처 코드의 등록·사용·잔여 수를 조회합니다
 * @summary 바우처 통계 조회
 */
export const getVoucherStats = (
  params: GetVoucherStatsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyVoucherStatsRes>(
    { url: `/vouchers/stats`, method: 'GET', params, signal },
    options,
  );
};

export const getGetVoucherStatsQueryKey = (params: GetVoucherStatsParams) => {
  return [`/vouchers/stats`, ...(params ? [params] : [])] as const;
};

export const getGetVoucherStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getVoucherStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetVoucherStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVoucherStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVoucherStatsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVoucherStats>>> = ({
    signal,
  }) => getVoucherStats(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVoucherStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVoucherStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVoucherStats>>
>;
export type GetVoucherStatsQueryError = ErrorType<unknown>;

export function useGetVoucherStats<
  TData = Awaited<ReturnType<typeof getVoucherStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetVoucherStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVoucherStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVoucherStats>>,
          TError,
          Awaited<ReturnType<typeof getVoucherStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVoucherStats<
  TData = Awaited<ReturnType<typeof getVoucherStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetVoucherStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVoucherStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVoucherStats>>,
          TError,
          Awaited<ReturnType<typeof getVoucherStats>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetVoucherStats<
  TData = Awaited<ReturnType<typeof getVoucherStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetVoucherStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVoucherStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary 바우처 통계 조회
 */

export function useGetVoucherStats<
  TData = Awaited<ReturnType<typeof getVoucherStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetVoucherStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVoucherStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetVoucherStatsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetVoucherStatsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getVoucherStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetVoucherStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVoucherStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVoucherStatsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVoucherStats>>> = ({
    signal,
  }) => getVoucherStats(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getVoucherStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetVoucherStatsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVoucherStats>>
>;
export type GetVoucherStatsSuspenseQueryError = ErrorType<unknown>;

export function useGetVoucherStatsSuspense<
  TData = Awaited<ReturnType<typeof getVoucherStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetVoucherStatsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVoucherStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVoucherStatsSuspense<
  TData = Awaited<ReturnType<typeof getVoucherStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetVoucherStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVoucherStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetVoucherStatsSuspense<
  TData = Awaited<ReturnType<typeof getVoucherStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetVoucherStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVoucherStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
/**
 * @summary 바우처 통계 조회
 */

export function useGetVoucherStatsSuspense<
  TData = Awaited<ReturnType<typeof getVoucherStats>>,
  TError = ErrorType<unknown>,
>(
  params: GetVoucherStatsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getVoucherStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetVoucherStatsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 로그인 사용자의 바우처 목록을 조회합니다. usableCount는 현재 사용 가능한 바우처 수입니다.
 * @summary 내 바우처 목록
 */
export const getMyVouchers = (
  params?: GetMyVouchersParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyUserVouchersRes>(
    { url: `/vouchers/my`, method: 'GET', params, signal },
    options,
  );
};

export const getGetMyVouchersQueryKey = (params?: GetMyVouchersParams) => {
  return [`/vouchers/my`, ...(params ? [params] : [])] as const;
};

export const getGetMyVouchersQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyVouchers>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyVouchersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyVouchers>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyVouchersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyVouchers>>> = ({
    signal,
  }) => getMyVouchers(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyVouchers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyVouchersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyVouchers>>
>;
export type GetMyVouchersQueryError = ErrorType<unknown>;

export function useGetMyVouchers<
  TData = Awaited<ReturnType<typeof getMyVouchers>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetMyVouchersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyVouchers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyVouchers>>,
          TError,
          Awaited<ReturnType<typeof getMyVouchers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyVouchers<
  TData = Awaited<ReturnType<typeof getMyVouchers>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyVouchersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyVouchers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyVouchers>>,
          TError,
          Awaited<ReturnType<typeof getMyVouchers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMyVouchers<
  TData = Awaited<ReturnType<typeof getMyVouchers>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyVouchersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyVouchers>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary 내 바우처 목록
 */

export function useGetMyVouchers<
  TData = Awaited<ReturnType<typeof getMyVouchers>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyVouchersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyVouchers>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMyVouchersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMyVouchersSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyVouchers>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyVouchersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyVouchers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyVouchersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyVouchers>>> = ({
    signal,
  }) => getMyVouchers(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyVouchers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyVouchersSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyVouchers>>
>;
export type GetMyVouchersSuspenseQueryError = ErrorType<unknown>;

export function useGetMyVouchersSuspense<
  TData = Awaited<ReturnType<typeof getMyVouchers>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetMyVouchersParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyVouchers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyVouchersSuspense<
  TData = Awaited<ReturnType<typeof getMyVouchers>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyVouchersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyVouchers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyVouchersSuspense<
  TData = Awaited<ReturnType<typeof getMyVouchers>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyVouchersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyVouchers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
/**
 * @summary 내 바우처 목록
 */

export function useGetMyVouchersSuspense<
  TData = Awaited<ReturnType<typeof getMyVouchers>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyVouchersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyVouchers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetMyVouchersSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
